import { render, staticRenderFns } from "./landing-page-treatment.vue?vue&type=template&id=bec20b8c&scoped=true&lang=pug"
import script from "./landing-page-treatment.js?vue&type=script&lang=js&external"
export * from "./landing-page-treatment.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-treatment.vue?vue&type=style&index=0&id=bec20b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec20b8c",
  null
  
)

export default component.exports